module.exports = __webpack_public_path__ + "media/images/lb/220-8effb6ca0b2ca109177f3dbdfe9da951.svg";